var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02388 16.4309L6.38721 13.859C6.1949 13.2749 6.09091 12.65 6.09091 12C6.09091 11.35 6.1949 10.7251 6.38721 10.141L3.02388 7.56906C2.36791 8.90272 2 10.4063 2 12C2 13.5937 2.36791 15.0973 3.02388 16.4309Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38722 10.141C7.16322 7.78407 9.37727 6.09091 12 6.09091C13.4091 6.09091 14.6818 6.59091 15.6818 7.40909L18.5909 4.5C16.8182 2.95455 14.5455 2 12 2C8.04825 2 4.65047 4.2621 3.0239 7.56906L6.38722 10.141Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C8.04713 22 4.64856 19.7367 3.02252 16.4282L6.38448 13.8507C7.15801 16.212 9.37417 17.9091 12 17.9091C13.2849 17.9091 14.4234 17.6065 15.325 17.0375L18.5179 19.5095C16.7701 21.1347 14.4391 22 12 22Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.1818H21.3182C21.4545 10.7727 21.5455 11.4091 21.5455 12C21.5455 15.2593 20.3531 17.8032 18.5179 19.5095L15.325 17.0375C16.369 16.3786 17.0953 15.3626 17.3636 14.0455H12V10.1818Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.e8d530c9c08f59b54d49ea9a190292ee.svg";
export { ForwardRef as ReactComponent };